import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListingComponent } from './listing/listing.component';
import { FeatureBetaGuard } from '../guards/feature-beta.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [ FeatureBetaGuard ],
    component: ListingComponent,
    data: {
      featureName: 'painel-devolucoes',
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShippingReturnRoutingModule { }
